<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>

    <el-form :model="formData" ref="form" :rules="rules" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="type != 'preview' ? 'licensePlate' : ''"
            :label="'车牌号' + (type == 'preview' ? '：' : '')"
            :class="{preview:type == 'preview'}"
          >
            <el-input v-model="formData.licensePlate" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ formData.licensePlate ? formData.licensePlate : '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="type != 'preview' ? 'price' : ''"
            :class="{preview:type == 'preview'}"
            :label="'运输单价(元)' + (type == 'preview' ? '：' : '')"
          >
            <el-input v-model="formData.price" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ formData.price ? formData.price : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item
            :class="{preview:type == 'preview'}"
            :label="'备注' + (type == 'preview' ? '：' : '')"
          >
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.remark"
              placeholder="300字以内"
              v-if="type != 'preview'"
            ></el-input>
            <span v-else>{{ formData.remark ? formData.remark : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { saveVehicle, getVehicleDetail, editVehicle } from '@/api/library/logistics'
export default {
  components: {},
  data() {
    return {
      type: '',
      formData: {
        licensePlate: '',
        price: '',
        remark: '',
        supplierId: '',
      },
      tableData: [],
      rules: {
        licensePlate: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
      },

      clickFlag: false,
    }
  },
  props: {
    supplierId: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.formData.supplierId = this.supplierId
  },

  methods: {
    reset() {
      this.formData = { licensePlate: '', price: '', remark: '', supplierId: this.supplierId }
      this.resetForm('form')
    },
    add(type) {
      this.type = type
    },
    getDetail(row, type) {
      this.type = type
      getVehicleDetail({ id: row.id })
        .then((res) => {
          if (res.flag) {
            this.formData.licensePlate = res.data.licensePlate
            this.formData.price = res.data.price
            this.formData.remark = res.data.remark
            this.formData.id = res.data.id
            this.formData.supplierId = this.supplierId
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })

      // this.formData.parentFullCodeList = row.parentFullCodeList
      // this.formData.name = row.name
      // this.formData.parentFullName = row.parentFullName
      // this.formData.level = row.level
      // this.formData.id = row.id
    },
    submit(type, callback) {
      if (this.clickFlag) {
        return
      }
      console.log(type, 'addddd')
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.clickFlag = true
          if (type == 'add') {
            saveVehicle(this.formData)
              .then((res) => {
                this.clickFlag = false
                if (res.flag) {
                  // this.tableData = res.data.items

                  this.reset()
                  callback(true)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                this.clickFlag = false
                console.log(error)
              })
          } else if (type == 'edit') {
            editVehicle(this.formData)
              .then((res) => {
                this.clickFlag = false
                if (res.flag) {
                  this.reset()
                  callback(true)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                this.clickFlag = false
                console.log(error)
              })
          }
        }
      })
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-button--text {
  font-size: 14px;
}
::v-deep {
  .el-form-item.preview {
    margin-bottom: 0;
  }
}
</style>